// extracted by mini-css-extract-plugin
export default {"row":"NewProduct_row__dLsSR","col":"NewProduct_col__or7D+","card":"NewProduct_card__0zEgK"};